type Printer = { id: string };
type PreferenceStorage = Pick<Storage, 'getItem' | 'setItem'>;
const key = (userId: string) => `ph.printing.preferred.${userId}`;
function browserStorage(): PreferenceStorage | undefined {
  try { return typeof window === 'undefined' ? undefined : window.localStorage; }
  catch { return undefined; }
}
export function preferredPrinter(printers: Printer[], userId?: string, storage = browserStorage()): string {
  let saved: string | null = null;
  try { if (userId) saved = storage?.getItem(key(userId)) ?? null; } catch { /* Storage is optional. */ }
  return printers.find(printer => printer.id === saved)?.id ?? printers[0]?.id ?? '';
}
export function rememberPrinter(printerId: string, userId?: string, storage = browserStorage()) {
  if (!printerId || !userId) return;
  try { storage?.setItem(key(userId), printerId); } catch { /* Printing must still work without storage. */ }
}
